import { useMutation, useQuery } from "@tanstack/react-query";

import { accountActionUrl, changePassword, fetchTwoFactorStatus, updateAvatar, updateProfile } from "@/data/account";
import { rememberPostLoginPath } from "@/lib/post-login-path";

export function useChangePassword() {
  return useMutation({ mutationFn: changePassword });
}

export function useUpdateAvatar() {
  return useMutation({
    mutationFn: (avatar: string | null) => updateAvatar(avatar),
  });
}

export function useUpdateProfile() {
  return useMutation({ mutationFn: updateProfile });
}

export function useTwoFactorStatus() {
  return useQuery({ queryKey: ["account", "two-factor"], queryFn: fetchTwoFactorStatus });
}

export function useAccountAction() {
  return useMutation({
    mutationFn: async (action: string) => {
      const url = await accountActionUrl(action);
      rememberPostLoginPath("/account");
      window.location.href = url;
    },
  });
}
